<template>
  <div class="hiring-process-section">
    <div class="container-fluid">
      <div class="text-center mb-4">
        <h2 class="hiring-title">
          Our <span class="text-orange">Hiring Process</span>
        </h2>
        <p class="hiring-subtitle">
          We often fast-track exceptional candidates, so prepare thoroughly and
          fill your application in detail!
        </p>
      </div>

      <div class="timeline-container">
        <div class="timeline-line"></div>
        <div class="timeline-steps">
          <div
            v-for="(process, index) in hiringProcess"
            :key="process.id"
            class="timeline-step"
            :class="{ reverse: index % 2 === 1 }"
          >
            <div class="step-content">
              <div class="step-number">{{ process.id }}</div>
              <div class="step-info">
                <h4 class="step-title">{{ process.title }}</h4>
                <p class="step-description">{{ process.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      hiringProcess: [],
    };
  },
  mounted() {
    this.hiringProcess = [
      {
        id: 1,
        title: "Interview Prep",
        description:
          "Read through the relevant Interview Prep Document for your role.",
      },
      {
        id: 2,
        title: "Apply",
        description:
          "Fill out the job application form with detailed information.",
      },
      {
        id: 3,
        title: "Shortlisting",
        description:
          "We review applications to match skills with job requirements.",
      },
      {
        id: 4,
        title: "Screening",
        description: "Fundamental knowledge test conducted onsite or online.",
      },
      {
        id: 5,
        title: "Task",
        description:
          "Practical assessment of technical and problem-solving skills.",
      },
      {
        id: 6,
        title: "Team Lead Interview",
        description:
          "Technical interview with team lead to assess field expertise.",
      },
      {
        id: 7,
        title: "CTO Interview",
        description: "In-depth technical interview with our CTO.",
      },
      {
        id: 8,
        title: "CEO Interview",
        description:
          "Final cultural fit and technical assessment with our CEO.",
      },
    ];
  },
};
</script>

<style scoped>
.hiring-process-section {
  padding: 40px 0;
  background-color: #1a1a1a;
}

.hiring-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
  letter-spacing: -0.01em;
}

.text-orange {
  color: #f47726;
}

.hiring-subtitle {
  font-size: 1rem;
  color: #b5b8ba;
  font-weight: 300;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.5;
}

.timeline-container {
  position: relative;
  max-width: 1000px;
  margin: 3rem auto 0;
  padding: 0 20px;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, #f47726 0%, rgba(244, 119, 38, 0.3) 100%);
  transform: translateX(-50%);
}

.timeline-steps {
  position: relative;
  z-index: 2;
}

.timeline-step {
  position: relative;
  margin-bottom: 2rem;
  opacity: 0;
  animation: fadeInUp 0.6s ease forwards;
}

.timeline-step:nth-child(1) {
  animation-delay: 0.1s;
}
.timeline-step:nth-child(2) {
  animation-delay: 0.2s;
}
.timeline-step:nth-child(3) {
  animation-delay: 0.3s;
}
.timeline-step:nth-child(4) {
  animation-delay: 0.4s;
}
.timeline-step:nth-child(5) {
  animation-delay: 0.5s;
}
.timeline-step:nth-child(6) {
  animation-delay: 0.6s;
}
.timeline-step:nth-child(7) {
  animation-delay: 0.7s;
}
.timeline-step:nth-child(8) {
  animation-delay: 0.8s;
}

.step-content {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  max-width: 450px;
  margin-left: calc(50% + 30px);
}

.timeline-step.reverse .step-content {
  margin-left: 0;
  margin-right: calc(50% + 30px);
  flex-direction: row-reverse;
  text-align: right;
}

.step-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #f47726 0%, #ff9a56 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  color: #ffffff;
  box-shadow: 0 4px 8px rgba(244, 119, 38, 0.3);
  position: relative;
  z-index: 3;
  flex-shrink: 0;
}

.step-number::before {
  content: "";
  position: absolute;
  top: 50%;
  width: 30px;
  height: 2px;
  background-color: #f47726;
  z-index: 1;
}

.timeline-step:not(.reverse) .step-number::before {
  right: 100%;
  margin-right: 10px;
}

.timeline-step.reverse .step-number::before {
  left: 100%;
  margin-left: 10px;
}

.step-info {
  flex: 1;
  min-width: 0;
}

.step-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.step-description {
  font-size: 0.9rem;
  color: #d0d0d0;
  line-height: 1.4;
  margin: 0;
  font-weight: 300;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .hiring-process-section {
    padding: 30px 0;
  }

  .hiring-title {
    font-size: 1.8rem;
  }

  .hiring-subtitle {
    font-size: 0.9rem;
    padding: 0 1rem;
  }

  .timeline-container {
    padding: 0 15px;
  }

  .timeline-line {
    left: 30px;
  }

  .step-content,
  .timeline-step.reverse .step-content {
    margin-left: 70px;
    margin-right: 0;
    flex-direction: row;
    text-align: left;
    max-width: none;
  }

  .step-number::before {
    display: none;
  }

  .step-number {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }

  .step-title {
    font-size: 1rem;
  }

  .step-description {
    font-size: 0.85rem;
  }

  .timeline-step {
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 480px) {
  .hiring-title {
    font-size: 1.5rem;
  }

  .step-content {
    gap: 1rem;
    margin-left: 60px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .step-title {
    font-size: 0.95rem;
  }

  .step-description {
    font-size: 0.8rem;
  }
}
</style>
